import { render } from "./CustomerIdentifierBatchRemoveModal.vue?vue&type=template&id=6b3ba78d"
import script from "./CustomerIdentifierBatchRemoveModal.vue?vue&type=script&lang=js"
export * from "./CustomerIdentifierBatchRemoveModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__